import { api } from '@/shared/api/client';

interface PostUpdateProgressProps {
  content_id: string;
  player_event: string;
  play_position_secs: number;
  progress_percent?: number;
  sound_volume: number;
  playback_speed: number;
  is_background_playing: boolean;
  course_id: string;
}

export const postUpdateProgress = async (params: PostUpdateProgressProps) => {
  const { content_id, ...payload } = params;
  const { data } = await api.post(
    `/contents/${content_id}/update-progress/`,
    payload,
  );
  return data;
};
